import { api } from '@api/api';
import { Option } from '@api/types/option';

const caseRoleApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCaseRoleOptions: build.query<Option[], void>({
      query: () => ({
        url: 'caseRole/options',
      }),
    }),
  }),
});

export const { useGetCaseRoleOptionsQuery } = caseRoleApi;
